import { TokenTextColor, TextAlignment, TokenTextAppearance, Text } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

interface StyledTextLegalProps {
	$fontSize?: string;
}

const StyledTextLegal = styled(Text)<StyledTextLegalProps>`
	font-size: ${({ $fontSize }) => $fontSize || '13px'};
`;

interface TextLegalProps {
	children: React.ReactNode;
	fontSize?: string;
}

export const HuchaDisclaimerTextLegal = ({ children, fontSize }: TextLegalProps): React.JSX.Element => {
	if (fontSize) {
		return (
			<StyledTextLegal $fontSize={fontSize} color={TokenTextColor.tertiary} textAlign={TextAlignment.center}>
				{children}
			</StyledTextLegal>
		);
	} else {
		return (
			<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.tertiary} textAlign={TextAlignment.center}>
				{children}
			</Text>
		);
	}
};
